export function setDocumentTitle(title: string) {
  document.title = title;
  const openGraphTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
  if (openGraphTitle) openGraphTitle.content = title;
}
